import { useContext } from 'react'
import {
  EmployeeQueryContext,
  EmployeeQueryContextValue
} from '../providers/EmployeeQueryProvider'

export function useEmployeeQuery(): EmployeeQueryContextValue | undefined {
  return useContext(EmployeeQueryContext)
}
